import { Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FilledLinkToWebField, ImageField, KeyTextField, RichTextField, Slice } from '@prismicio/client';
import { AosDirective } from '../../aos/aos.directive';
import { RenderHtmlPipe } from '../render-html/render-html.pipe';

@Component({
    selector: 'app-projects-slice',
    templateUrl: './projects-slice.component.html',
    styleUrls: ['./projects-slice.component.scss'],
    standalone: true,
    imports: [AosDirective, RenderHtmlPipe, ReactiveFormsModule, RenderHtmlPipe]
})
export class ProjectsSliceComponent implements OnInit {
    @Input() body?: ProjectsSlice;

    ngOnInit() {}
}

export type ProjectsSlice = Slice<
    'projects',
    never,
    {
        heading: KeyTextField;
        title: KeyTextField;
        description: RichTextField;
        image: ImageField;
        link: FilledLinkToWebField;
    }
>;
